import { createEvent, sample } from 'effector'
import { fx } from '../../../../libs'
import { env } from '../../../../libs/constants'

export const submitAccept2FA = createEvent<string>()

export const accept2FA = fx<{ uuid: string }, void>({
  method: 'POST',
  url: '/user/accept_2fa',
  baseUrl: env.baseUrl && env.baseUrl.replace('/v1', '/public'),
})

sample({
  clock: submitAccept2FA,
  fn: (id) => {
    return {
      body: {
        uuid: id,
      },
    }
  },
  target: accept2FA,
})
